import { createWebHistory, createRouter } from "vue-router";
import Dashboard from '../components/Dashboard.vue';
import Error from '../components/Error.vue';

const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/error',
    name: 'error',
    component: Error
  },
  {
    path: '/:pathMatch(.*)*',
    component: Dashboard
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
